<template>
  <div>
    <div class="table-header">
      <div>
        <el-radio-group v-model="tabPosition" style="margin-bottom: 20px" @change="handleTabChange">
          <el-radio-button label="有效">有效</el-radio-button>
          <el-radio-button label="失效">失效</el-radio-button>
        </el-radio-group>
      </div>
      <div>
        <el-button type="primary" size="small" @click="handleAdd" :disabled="!isAuthorizedUser()"
          >添加</el-button
        >
      </div>
    </div>
    <el-table
      :data="tableData"
      style="width: 100%"
      :header-cell-style="headerStyle"
      :row-class-name="tableRowClassName"
    >
      <el-table-column label="序号" align="center" width="80" type="index"></el-table-column>
      <el-table-column prop="companyName" label="合作资源单位-公司名称" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.companyName || '-' }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="shortName" label="简称" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.shortName || '-' }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="area" label="合作区域/园区" align="center" width="250">
        <template slot-scope="scope">
          <div v-if="scope.row.areas && scope.row.areas.length" class="tag-container">
            <el-tag
              v-for="(area, index) in typeof scope.row.areas === 'string'
                ? JSON.parse(scope.row.areas)
                : scope.row.areas"
              :key="index"
              size="small"
              type="success"
              class="skill-tag"
              >{{ area }}</el-tag
            >
          </div>
          <div v-else>-</div>
        </template>
      </el-table-column>
      <el-table-column prop="contact" label="联系人" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.contact || '-' }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="phone" label="电话" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.phone || '-' }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="role" label="角色" align="center">
        <template slot-scope="scope">
          <span style="color: #219aff">{{ scope.row.role || '-' }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="status" label="状态" align="center" width="80">
        <template slot-scope="scope">
          <span>{{ scope.row.status || '-' }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="120">
        <template slot-scope="scope">
          <el-dropdown @command="(command) => handleCommand(command, scope.row)">
            <span class="el-dropdown-link">
              更多操作 <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="edit" :disabled="!isAuthorizedUser">编辑</el-dropdown-item>
              <el-dropdown-item
                command="delete"
                :disabled="!isAuthorizedUser() || scope.row.status !== '失效'"
                >删除</el-dropdown-item
              >
              <el-dropdown-item command="history">历史记录</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-container">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageParams.skip"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageParams.limit"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>

    <!-- 编辑抽屉 -->
    <el-drawer
      :title="isEdit ? '编辑合作资源单位' : '添加合作资源单位'"
      :visible.sync="dialogVisible"
      direction="rtl"
      size="30%"
      :before-close="handleClose"
    >
      <div>
        <el-form :model="form" :rules="rules" label-width="120px" label-position="right">
          <el-form-item label="公司名称" prop="companyName">
            <el-input v-model="form.companyName" placeholder="请输入公司名称"></el-input>
          </el-form-item>
          <el-form-item label="简称" prop="shortName">
            <el-input v-model="form.shortName" placeholder="请输入简称"></el-input>
          </el-form-item>
          <el-form-item label="合作区域/园区" prop="areas">
            <el-select v-model="form.areas" multiple placeholder="请选择" style="width: 100%">
              <el-option label="上海-临港" value="上海-临港"></el-option>
              <el-option label="上海-书院" value="上海-书院"></el-option>
              <el-option label="杭州-东冠" value="杭州-东冠"></el-option>
              <el-option label="杭州-通普" value="杭州-通普"></el-option>
              <el-option label="杭州-枢纽" value="杭州-枢纽"></el-option>
              <el-option label="杭州-萧山" value="杭州-萧山"></el-option>
              <el-option label="清远-清新" value="清远-清新"></el-option>
              <el-option label="怀来-东园" value="怀来-东园"></el-option>
              <el-option label="惠州-联丰" value="惠州-联丰"></el-option>
              <el-option label="昆山-千灯" value="昆山-千灯"></el-option>
              <el-option label="韶关-沐阳" value="韶关-沐阳"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="联系人" prop="contact">
            <el-input v-model="form.contact" placeholder="请输入联系人"></el-input>
          </el-form-item>
          <el-form-item label="电话" prop="phone">
            <el-input v-model="form.phone" placeholder="请输入电话"></el-input>
          </el-form-item>
          <el-form-item label="角色" prop="role">
            <el-input v-model="form.role" placeholder="请输入角色"></el-input>
          </el-form-item>
          <el-form-item label="状态" prop="status">
            <el-select v-model="form.status" placeholder="请选择" style="width: 100%">
              <el-option label="有效" value="有效"></el-option>
              <el-option label="失效" value="失效"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="submitForm">确定</el-button>
            <el-button @click="handleClose">取消</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-drawer>
    <history-dialog :visible.sync="historyDialogVisible" :partnerId="currentEmployeeId" />
  </div>
</template>
    
<script>
import {
  getPartnerList,
  createPartner,
  updatePartner,
  deletePartner,
  getPartnerDetail,
} from '@/api/partner';
import HistoryDialog from './HistoryDialog.vue';

export default {
  components: {
    HistoryDialog,
  },
  data() {
    return {
      headerStyle: {
        background: '#F5F7FA',
        color: '#303133',
        fontWeight: 'bold',
        textAlign: 'center',
      },
      loading: false,
      total: 0,
      pageParams: {
        skip: 1,
        limit: 10,
        status: '有效',
      },
      tabPosition: '有效',
      tableData: [],
      dialogVisible: false,
      drawerTitle: '',
      form: {
        companyName: '',
        shortName: '',
        areas: [],
        contact: '',
        phone: '',
        role: '',
        status: '有效',
        remark: '',
      },
      rules: {
        companyName: [{ required: true, message: '请输入公司名称', trigger: 'blur' }],
        // contact: [{ required: true, message: '请输入联系人', trigger: 'blur' }],
        phone: [
          // { required: true, message: '请输入电话号码', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号码', trigger: 'blur' },
        ],
        status: [{ required: true, message: '请选择状态', trigger: 'change' }],
      },
      isEdit: false,
      editIndex: -1,
      historyDialogVisible: false,
      currentEmployeeId: null,
    };
  },
  methods: {
    tableRowClassName({ rowIndex }) {
      return rowIndex % 2 === 0 ? 'even-row' : 'odd-row';
    },
    handleAdd() {
      this.drawerTitle = '添加员工';
      this.isEdit = false;
      this.form = {
        companyName: '',
        shortName: '',
        areas: [],
        contact: '',
        phone: '',
        role: '',
        status: '有效',
        remark: '',
      };
      this.dialogVisible = true;
    },
    async handleCommand(command, row) {
      this.currentEmployeeId = row.id;
      switch (command) {
        case 'edit':
          this.drawerTitle = '编辑合作资源单位';
          this.isEdit = true;
          this.editIndex = this.tableData.findIndex((item) => item.id === row.id);
          try {
            const res = await getPartnerDetail(row.id);
            const partnerData = res.data.data;
            this.form = {
              companyName: partnerData.data.name,
              shortName: partnerData.data.address,
              areas: partnerData.data.regions ? JSON.parse(partnerData.data.regions) : [],
              contact: partnerData.data.contact_person,
              phone: partnerData.data.phone,
              role: partnerData.data.remark,
              status: partnerData.data.status,
              remark: partnerData.data.remark,
            };
            this.currentEmployeeId = row.id;
            this.dialogVisible = true;
          } catch (error) {
            this.$message.error('获取详情失败：' + error.message);
          }
          break;
        case 'delete':
          this.$confirm('确认删除该员工信息吗？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          })
            .then(async () => {
              try {
                await deletePartner(row.id);
                this.$message.success('删除成功');
                this.getList();
              } catch (error) {
                this.$message.error('删除失败：' + error.message);
              }
            })
            .catch(() => {});
          break;
        case 'history':
          this.historyDialogVisible = true;
          break;
        default:
          break;
      }
    },
    handleClose() {
      this.dialogVisible = false;
    },
    async submitForm() {
      try {
        const submitData = {
          name: this.form.companyName,
          address: this.form.shortName,
          regions: JSON.stringify(this.form.areas),
          contact_person: this.form.contact,
          phone: this.form.phone,
          remark: this.form.role,
          status: this.form.status,
          operator: localStorage.getItem('UserId') || 'admin',
        };
        if (this.isEdit) {
          await updatePartner(this.currentEmployeeId, submitData);
          this.$message.success('编辑成功');
        } else {
          await createPartner(submitData);
          this.$message.success('添加成功');
        }
        this.dialogVisible = false;
        this.getList();
      } catch (error) {
        if (error.message) {
          this.$message.error('操作失败：' + error.message);
        }
      }
    },
    async getList() {
      this.loading = true;
      try {
        const res = await getPartnerList(this.pageParams);
        this.tableData = (res.data.data.list || []).map((item) => ({
          id: item.id,
          companyName: item.name,
          shortName: item.address,
          areas: item.regions ? JSON.parse(item.regions) : [],
          contact: item.contact_person,
          phone: item.phone,
          role: item.remark,
          status: item.status,
        }));
        this.total = res.data.data.total || 0;
      } catch (error) {
        this.$message.error('获取列表失败：' + error.message);
      } finally {
        this.loading = false;
      }
    },
    handleSizeChange(val) {
      this.pageParams.limit = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.pageParams.skip = val;
      this.getList();
    },
    handleTabChange() {
      this.pageParams.status = this.tabPosition;
      this.getList();
    },
    handleHistory() {
      this.historyDialogVisible = true;
    },
    isAuthorizedUser() {
      const authorizedUsers = ['卢旭', '朱泳仪', '韩林达', '周德明', '何文卷', '陈伟锋'];
      const currentUser = localStorage.getItem('UserId') || '';
      return authorizedUsers.includes(currentUser);
    },
  },
  created() {
    this.getList();
  },
};
</script>

<style lang="scss" scoped>
.container {
  padding: 20px;
}
.title {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 30px;
}
.title-en {
  margin: 10px 0;
  padding-left: 10px;
  border-left: 3px solid #219aff;
  font-weight: normal;
}
.box-card {
  margin-bottom: 20px;
}
.table-header {
  display: flex;
  justify-content: space-between;
}
.el-dropdown-link {
  cursor: pointer;
  color: #409eff;
}

::v-deep .el-table {
  th.el-table__cell {
    background-color: #4e71be !important;
    border: 0.5px solid #fff;
    .cell {
      white-space: pre-line;
      line-height: 1.5;
      color: #fff;
    }
  }
  th.el-table__cell:first-child {
    border: 0.5px solid #fff;
  }
  .el-table__header {
    border-color: #fff;
  }
  td.el-table__cell {
    border: 0.5px solid #fff;
    .cell {
      white-space: pre-line;
      line-height: 1.5;
    }
  }
  td.el-table__cell:first-child {
    background-color: #4e71be !important;
    color: #fff;
  }
  tr:hover > td.el-table__cell:first-child {
    background-color: #4e71be !important;
  }
}

::v-deep .el-table .even-row {
  background-color: #ced4e8;
}

::v-deep .el-table .odd-row {
  background-color: #e9ebf3;
}

::v-deep .el-table td.el-table__cell .cell {
  white-space: normal !important;
}

.pagination-container {
  margin-top: 15px;
  display: flex;
  justify-content: flex-end;
}

.tag-container {
  display: flex;
  flex-wrap: wrap;
}

.skill-tag {
  margin: 2px;
}
</style>